<template>
  <svg
    :class="['animate-spin', sizeClass]"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true">
    <circle
      class="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      stroke-width="4" />
    <path
      class="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
  </svg>
</template>

<script>
const SIZES = { sm: 'w-4 h-4', md: 'w-5 h-5', lg: 'w-6 h-6' }

export default {
  name: 'AppSpinner',
  props: {
    size: { type: String, default: 'md' },
  },
  computed: {
    sizeClass() {
      return SIZES[this.size] ?? SIZES.md
    },
  },
}
</script>
